var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBringForward(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 10.9375V1.9375C12.375 1.02344 11.6016 0.25 10.6875 0.25H1.6875C0.738281 0.25 0 1.02344 0 1.9375V10.9375C0 11.8867 0.738281 12.625 1.6875 12.625H10.6875C11.6016 12.625 12.375 11.8867 12.375 10.9375ZM1.6875 1.9375H10.6875V10.9375H1.6875V1.9375ZM16.3125 5.875H13.5V7.5625H16.3125V16.5625H7.3125V13.75H5.625V16.5625C5.625 17.5117 6.36328 18.25 7.3125 18.25H16.3125C17.2266 18.25 18 17.5117 18 16.5625V7.5625C18 6.64844 17.2266 5.875 16.3125 5.875ZM8.4375 14.875C8.4375 15.1914 8.68359 15.4375 9 15.4375H14.625C14.9062 15.4375 15.1875 15.1914 15.1875 14.875V9.25C15.1875 8.96875 14.9062 8.6875 14.625 8.6875H13.5V13.75H8.4375V14.875Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBringForward);
export default __webpack_public_path__ + "static/media/bring-forward.aef6aaee2bb2972209c6012f531d5457.svg";
export { ForwardRef as ReactComponent };